(() => {
  if (customElements.get('cro-delivery-date')) return;
      var TZ = 'Europe/Copenhagen';

      var RULES = {
        DK: { cutoff: 12, locale: 'da-DK', shipDays: [1,2,3,4,5] },
        SE: { cutoff: 11, locale: 'sv-SE', shipDays: [1,2,3,4,5] },
        NO: { cutoff: 12, locale: 'nb-NO', shipDays: [1,2,3,4,5] },
        DE: { cutoff: 12, locale: 'de-DE', shipDays: [1,3,5] }
      };

      function easter(y) {
        var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
            f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
            h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
            l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
            month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
        return Date.UTC(y, month - 1, day);
      }
      var DAY = 86400000;
      function key(t) { return new Date(t).toISOString().slice(0, 10); }

      var holidayCache = {};
      function holidays(country, y) {
        var ck = country + y;
        if (holidayCache[ck]) return holidayCache[ck];
        var E = easter(y), set = {};
        function add(t) { set[key(t)] = true; }
        function fixed(m, d) { add(Date.UTC(y, m - 1, d)); }
        fixed(1, 1); fixed(12, 24); fixed(12, 25); fixed(12, 26); fixed(12, 31);
        if (country === 'DK') {
          add(E - 3 * DAY); add(E - 2 * DAY); add(E); add(E + DAY);
          add(E + 39 * DAY); add(E + 49 * DAY); add(E + 50 * DAY); fixed(6, 5);
        } else if (country === 'SE') {
          fixed(1, 6); add(E - 2 * DAY); add(E + DAY); fixed(5, 1);
          add(E + 39 * DAY); fixed(6, 6);
          for (var d = 19; d <= 25; d++) { var t = Date.UTC(y, 5, d); if (new Date(t).getUTCDay() === 5) add(t); }
        } else if (country === 'NO') {
          add(E - 3 * DAY); add(E - 2 * DAY); add(E + DAY); fixed(5, 1); fixed(5, 17);
          add(E + 39 * DAY); add(E + 50 * DAY);
        } else if (country === 'DE') {
          add(E - 2 * DAY); add(E + DAY); fixed(5, 1); add(E + 39 * DAY); add(E + 50 * DAY); fixed(10, 3);
        }
        holidayCache[ck] = set;
        return set;
      }
      function isHoliday(country, t) { return !!holidays(country, new Date(t).getUTCFullYear())[key(t)]; }
      function isWeekend(t) { var w = new Date(t).getUTCDay(); return w === 0 || w === 6; }
      function isBizDay(country, t) { return !isWeekend(t) && !isHoliday(country, t); }
      function addBizDays(country, t, n) {
        var c = 0;
        while (c < n) { t += DAY; if (isBizDay(country, t)) c++; }
        return t;
      }

      function nowParts(now) {
        var p = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
          .formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
        return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, min: +p.minute, s: +p.second };
      }

      function fmt(locale, t, withWeekday) {
        var o = { timeZone: 'UTC', day: 'numeric', month: 'short' };
        if (withWeekday) o.weekday = 'long';
        return new Intl.DateTimeFormat(locale, o).format(new Date(t));
      }

  class CroDeliveryDate extends HTMLElement {
    connectedCallback() { this.render(); }

    render(now = new Date()) {
      const text = this.querySelector('.cro-delivery-date__text');
      const country = this.dataset.croCountry;
      const rule = RULES[country];
      this.hidden = true;
      if (!text || !rule || this.dataset.shippable !== 'true') return;

      const n = nowParts(now);
      const today = Date.UTC(n.y, n.m - 1, n.d);
      const minutes = rule.cutoff * 60 - n.h * 60 - n.min;
      const dispatchesToday = minutes > 0 && rule.shipDays.includes(new Date(today).getUTCDay()) && !isHoliday('DK', today);
      if (!dispatchesToday) {
        if (this.dataset.context === 'product' && this.dataset.fallback) {
          text.textContent = this.dataset.fallback;
          this.hidden = false;
        }
        return;
      }

      const locale = this.dataset.locale || 'en';
      const countdown = this.dataset.countdown
        .replace('[HOURS]', Math.floor(minutes / 60))
        .replace('[MINUTES]', minutes % 60);
      if (this.dataset.context === 'product') {
        text.textContent = this.dataset.compactEstimate.replace('[COUNTDOWN]', countdown);
        this.hidden = false;
        return;
      }
      let dates;
      let homeDate = '';
      let message = this.dataset.estimate;
      if (country === 'DK') {
        const tomorrow = today + DAY;
        if (new Date(tomorrow).getUTCDay() === 6 && !isHoliday('DK', tomorrow)) {
          dates = fmt(locale, tomorrow, true);
          homeDate = fmt(locale, addBizDays('DK', tomorrow, 1), true);
          message = this.dataset.saturdayEstimate;
        } else {
          dates = fmt(locale, addBizDays('DK', today, 1), true);
        }
      } else {
        const range = country === 'SE' ? [1, 3] : country === 'NO' ? [2, 5] : [3, 3];
        dates = fmt(locale, addBizDays(country, today, range[0]), true);
        if (range[0] !== range[1]) dates += ' – ' + fmt(locale, addBizDays(country, today, range[1]), true);
      }
      text.textContent = message.replace('[COUNTDOWN]', countdown).replace('[DATES]', dates).replace('[HOME_DATE]', homeDate);
      this.hidden = false;
    }
  }

  customElements.define('cro-delivery-date', CroDeliveryDate);
  const refresh = () => document.querySelectorAll('cro-delivery-date').forEach(el => el.render());
  setInterval(refresh, 30000);
  document.addEventListener('on:cart:after-merge', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
